import React from 'react';
import { Layout, Menu } from 'antd';
import { 
  BarChartOutlined, 
  UserOutlined, 
  SettingOutlined,
  DashboardOutlined,
  TeamOutlined,
  FileTextOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { theme } from '../../../styles/theme';

const { Sider } = Layout;

const AdminSidebar = ({ collapsed, onCollapse }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      key: '/admin',
      icon: <DashboardOutlined />,
      label: 'Admin Dashboard',
    },
    {
      key: '/analytics',
      icon: <BarChartOutlined />,
      label: 'Analytics Dashboard',
    },
    {
      key: '/admin/users',
      icon: <TeamOutlined />,
      label: 'User Management',
    },
    {
      key: '/admin/quotes',
      icon: <FileTextOutlined />,
      label: 'Quote Management',
    },
    {
      key: '/admin/settings',
      icon: <SettingOutlined />,
      label: 'Settings',
    }
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      width={250}
      style={{
        background: '#fff',
        boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        zIndex: 1000,
        overflow: 'auto'
      }}
    >
      <div style={{
        padding: '16px',
        borderBottom: '1px solid #f0f0f0',
        textAlign: 'center'
      }}>
        {!collapsed ? (
          <h2 style={{
            margin: 0,
            color: theme.colors.primary,
            fontFamily: theme.fonts.primary,
            fontSize: '18px',
            fontWeight: 'bold'
          }}>
            HSP Admin
          </h2>
        ) : (
          <div style={{
            color: theme.colors.primary,
            fontSize: '24px',
            fontWeight: 'bold'
          }}>
            H
          </div>
        )}
      </div>
      
      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}
        items={menuItems}
        onClick={handleMenuClick}
        style={{
          border: 'none',
          marginTop: '16px'
        }}
        theme="light"
      />
      
      <div style={{
        position: 'absolute',
        bottom: '16px',
        left: '16px',
        right: '16px',
        padding: '12px',
        background: '#f8f9fa',
        borderRadius: '8px',
        fontSize: '12px',
        color: theme.colors.gray,
        textAlign: 'center'
      }}>
        {!collapsed ? (

            
            <div>Admin Panel v1.0</div>
          
        ) : (
          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>HSP</div>
        )}
      </div>
    </Sider>
  );
};

export default AdminSidebar;
